import { Card, Table, Typography } from 'antd';
import BrandLogo from '../components/BrandLogo';

const { Title, Text } = Typography;

// Бренды у которых есть logo.webp в /public/brands/
const BRANDS = [
  'OilWay',
  'Mobil',
  'ROLF',
  'TAIF',
  'ZIC',
  'LAVR',
  'SINOPEC',
  'FELIX',
  'Devon',
];

const SIZES: Array<{ label: string; size: string | number }> = [
  { label: '0.9em (в таблице)', size: '0.9em' },
  { label: '1.2em', size: '1.2em' },
  { label: '1.5em', size: '1.5em' },
  { label: '2em', size: '2em' },
  { label: '48 px', size: 48 },
];

const BrandsTestPage: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Тестовая страница логотипов брендов</Title>
      <Text type="secondary">
        Превью всех загруженных логотипов в разных размерах и контекстах. Используется компонент
        <Text code>&lt;BrandLogo /&gt;</Text>.
      </Text>

      {/* 1. Простая таблица — бренд × размер */}
      <Card title="1. Разные размеры" style={{ marginTop: 24 }}>
        <Table
          rowKey="brand"
          size="small"
          pagination={false}
          dataSource={BRANDS.map((b) => ({ brand: b }))}
          columns={[
            {
              title: 'Бренд',
              dataIndex: 'brand',
              width: 140,
              render: (b: string) => <Text strong>{b}</Text>,
            },
            ...SIZES.map((s) => ({
              title: s.label,
              key: `s-${s.label}`,
              render: (_: unknown, r: { brand: string }) => (
                <BrandLogo brand={r.brand} size={s.size} maxWidthRatio={8} />
              ),
            })),
          ]}
        />
      </Card>

      {/* 2. В контексте — как в каталоге (логотип + название товара) */}
      <Card title="2. В строке с названием товара (как в каталоге)" style={{ marginTop: 24 }}>
        <div style={{ fontSize: 14, lineHeight: '32px' }}>
          {BRANDS.map((b) => (
            <div key={b} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0' }}>
              <span style={{ minWidth: 100, color: '#999' }}>{b}</span>
              <BrandLogo brand={b} />
              <span>
                Super X7000 5W-30, 4 л <Text type="secondary">(артикул 123456)</Text>
              </span>
            </div>
          ))}
        </div>
      </Card>

      {/* 3. Крупно, рядом друг с другом */}
      <Card title="3. Крупно (высота 64 px) — выравнивание и контраст" style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', gap: 32, alignItems: 'center', flexWrap: 'wrap' }}>
          {BRANDS.map((b) => (
            <div key={b} style={{ textAlign: 'center' }}>
              <div
                style={{
                  height: 80,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: 160,
                }}
              >
                <BrandLogo brand={b} size={64} maxWidthRatio={6} />
              </div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {b}
              </Text>
            </div>
          ))}
        </div>
      </Card>

      {/* 4. На тёмном фоне — проверка прозрачности */}
      <Card title="4. На тёмном фоне (проверка прозрачности)" style={{ marginTop: 24 }}>
        <div
          style={{
            background: '#1f1f1f',
            padding: 24,
            display: 'flex',
            gap: 32,
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          {BRANDS.map((b) => (
            <div key={b} style={{ textAlign: 'center', color: '#fff' }}>
              <div style={{ height: 48, display: 'flex', alignItems: 'center' }}>
                <BrandLogo brand={b} size={40} maxWidthRatio={6} />
              </div>
              <Text style={{ fontSize: 12, color: '#aaa' }}>{b}</Text>
            </div>
          ))}
        </div>
      </Card>

      {/* 5. Бренд без логотипа — fallback */}
      <Card title="5. Fallback — бренд без загруженного логотипа" style={{ marginTop: 24 }}>
        <div style={{ fontSize: 14 }}>
          <BrandLogo brand="НесуществующийБренд123" /> — должно показаться просто как текст.
        </div>
      </Card>
    </div>
  );
};

export default BrandsTestPage;
